import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchPincodeDeatails = createAsyncThunk(
  "pincode/fetchDetails",
  async (pincode, { rejectWithValue }) => {
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = response.data[0];
      if (data.Status === "Success") {
        return data.PostOffice; // ✅ return array of Post Offices
      } else {
        return rejectWithValue("No data found for this pincode.");
      }
    } catch (error) {
      return rejectWithValue("Failed to fetch pincode details.");
    }
  }
);
 const 
 pincodeSlice = createSlice({
 name : "pincode", 
 initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearPincodeState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers :(builder)=>{
  builder.addCase(fetchPincodeDeatails.pending,(state)=>{
     state.loading = true; 
     state.error = null;  
  })
  .addCase(fetchPincodeDeatails.fulfilled,(state,action)=>{
    state.loading = false;
    state.data = action.payload;
  })
  .addCase(fetchPincodeDeatails.rejected,(state,action)=>{
    state.loading=false; 
    state.error = action.payload;
  });
  }, 
 })

  export const { clearPincodeState} = pincodeSlice.actions; 
  export default pincodeSlice.reducer;